var exports = {
  "W$": "MenuItem.module__subtext___OVhFcG",
  "z": "MenuItem.module__sliderItem___OVhFcG",
  "r9": "MenuItem.module__disabled___OVhFcG",
  "Ry": "MenuItem.module__sliderHeader___OVhFcG",
  "KF": "MenuItem.module__sliderLabel___OVhFcG",
  "rv": "MenuItem.module__sliderValue___OVhFcG",
  "xJ": "MenuItem.module__sliderContainer___OVhFcG",
};

module.exports = exports;
